import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import List from 'antd/es/list';

import Notification from './Notification';
import { EQUIPMENT_TYPE } from 'config/process';

const NotificationsList = ({ data, header, footer, pagination, isLoading, onItemClicked, className }) => {
  const history = useHistory();

  const onNotificationClicked = (item) => {
    if (item.equipment_type === EQUIPMENT_TYPE.CONTAINER) {
      history.push(`/containers/${item.container_id}`);
    } else if (item.equipment_type === EQUIPMENT_TYPE.TRAILER) {
      history.push(`/trailers/${item.container_id}`);
    }
    if (typeof onItemClicked === 'function') {
      onItemClicked(item);
    }
  };

  return (
    <StyledNotificationsList
      className={className}
      header={header}
      footer={footer}
      gutter={0}
      pagination={pagination}
      dataSource={data}
      loading={isLoading}
      locale={{
        emptyText: 'No notifications'
      }}
      renderItem={item => (
        <List.Item key={item.notification_id} onClick={() => onNotificationClicked(item)}>
          <Notification item={item} />
        </List.Item>
      )}
    />
  );
};

const StyledNotificationsList = styled(List)`
  background-color: #FFFFFF;
  padding: 8px;

  & .ant-list-header {
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    color: #232526;
    padding: 8px 0 14px 12px;
  }

  & .ant-list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 !important;
    padding: 4px !important;
    transition: background .3s ease;
    cursor: pointer;

    &:hover {
      background-color: #FAFBFC;
    }
  }

  & .ant-list-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #A4B0BA;
    padding: 0;
    padding-bottom: 8px;
  }

  & .ant-list-empty-text {
    box-shadow: inset 0px -1px 0px #EFF2F5;
  }

  & .ant-list-pagination {
    background-color: #fafbfc;
    padding-top: 24px;
    margin-top: 10px;
    margin-left: -16px;
    margin-right: -8px;
    margin-bottom: -10px;
  }

  & .ant-list-footer {
    padding: 14px 0 8px 0;
  }

  & .ant-dropdown-menu-items {
    padding: 0;
  }
`;

export default NotificationsList;
